/**
 * @module validator
 */

/**
 * validate a string is valid google analytics id or not.
 */
export function isGoogleAnalyticsId(arg: string) {
	return /^ua-\d{4,9}-\d{1,4}$/i.test(arg);
}
